import React, { useState } from "react";
import { Box, Typography, Chip, Grid, Grow, alpha, Zoom } from "@mui/material";
import { PlanCard } from "./PlanCard";
import { styled, keyframes } from "@mui/material/styles";

const shimmer = keyframes`
  0% { background-position: -1000px 0; }
  100% { background-position: 1000px 0; }
`;
const GradientText = styled("span")(({ theme }) => ({
  background: "linear-gradient(135deg, #2E9E53 0%, #45B7A0 50%, #0B4064 100%)",
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontWeight: "inherit",
  backgroundSize: "200% 200%",
  animation: `${shimmer} 3s ease-in-out infinite`,
}));

const PricingSection = ({ plans }) => {
  const [selectedPlan, setSelectedPlan] = useState(null);

  if (!plans || plans.length === 0) {
    return (
      <Box sx={{ textAlign: "center", py: 8 }}>
        <Typography sx={{ color: "#666" }}>
          No plans available at the moment.
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      id="pricing"
      sx={{
        background: "linear-gradient(135deg, #F7F7F7 0%, #E8F4F8 100%)",
        py: { xs: 5, sm: 7, md: 10 },
        px: { xs: 2, sm: 4, md: 8 },
      }}
    >
      <Box sx={{ maxWidth: "1400px", mx: "auto" }}>
        {/* Section Header */}
        <Box
          sx={{
            textAlign: "center",
            mb: { xs: 3, md: 3 },
            maxWidth: "800px",
            mx: "auto",
          }}
        >
          <Grow in timeout={800}>
            <Chip
              label="POWERFUL FEATURES"
              sx={{
                bgcolor: alpha("#2E9E53", 0.1),
                color: "#2E9E53",
                fontWeight: 800,
                mb: 3,
                px: 3,
                py: 2.5,
                fontSize: "0.9rem",
                border: `1px solid ${alpha("#2E9E53", 0.3)}`,
                "& .MuiChip-icon": { color: "#2E9E53" },
              }}
            />
          </Grow>
          <Zoom in timeout={1000}>
            <Typography
              variant="h2"
              sx={{
                fontWeight: 900,
                color: "#0B4064",
                fontFamily: "'Archivo Black', sans-serif",
                fontSize: {
                  xs: "1.8rem",
                  sm: "2.2rem",
                  md: "3rem",
                  lg: "3.5rem",
                },
                lineHeight: 1.2,
                mb: { xs: 1.5, md: 2 },
              }}
            >
              Choose Your <GradientText>Plan</GradientText>
            </Typography>
          </Zoom>
          <Typography
            variant="h5"
            sx={{
              color: "#2D3142",
              maxWidth: "800px",
              mx: "auto",
              // mb: 4,
              lineHeight: 1.8,
              fontSize: { xs: "1.1rem", md: "1.3rem" },
            }}
          >
            Flexible pricing designed to grow with your business — no hidden
            costs, no surprises.
          </Typography>
        </Box>

        {/* Plans Grid */}
        <Grid
          container
          spacing={{ xs: 3, md: 4 }}
          justifyContent="center"
          alignItems="flex-start"
        >
          {plans.map((plan, index) => (
            <Grid
              item
              key={plan._id || index}
              xs={12}
              sm={plans.length === 1 ? 8 : 6}
              md={plans.length === 1 ? 6 : 4}
              lg={plans.length === 1 ? 4 : 4}
              sx={{ mx: "auto" }}
            >
              <PlanCard
                plan={plan}
                index={index}
                selected={selectedPlan}
                onSelect={setSelectedPlan}
              />
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default PricingSection;
